var map = {
	"./add-circle.svg": 539,
	"./add.svg": 540,
	"./alarm.svg": 541,
	"./arrow-bottom.svg": 542,
	"./arrow-left.svg": 543,
	"./arrow-right.svg": 544,
	"./arrow-top.svg": 545,
	"./arrows-x.svg": 546,
	"./arrows-y.svg": 547,
	"./arrows.svg": 548,
	"./bin.svg": 549,
	"./binoculars.svg": 550,
	"./border-tree-corner.svg": 551,
	"./border-tree.svg": 552,
	"./call-back.svg": 553,
	"./cancel.svg": 554,
	"./chat.svg": 555,
	"./check-validate.svg": 556,
	"./check.svg": 557,
	"./check2.svg": 558,
	"./checkmark.svg": 559,
	"./circle-bin.svg": 560,
	"./close.svg": 561,
	"./cross.svg": 562,
	"./duplicate.svg": 563,
	"./floppy.svg": 564,
	"./folder.svg": 565,
	"./help.svg": 326,
	"./home.svg": 566,
	"./key.svg": 567,
	"./left-alignment.svg": 568,
	"./list.svg": 569,
	"./lock.svg": 570,
	"./logout.svg": 571,
	"./magnifying-glass.svg": 572,
	"./message.svg": 573,
	"./pen.svg": 574,
	"./reduce.svg": 575,
	"./visibility-off.svg": 576,
	"./visibility.svg": 577
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 538;


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons ^\.\/.*\.svg$
// module id = 538
// module chunks = 0